// extracted by mini-css-extract-plugin
export default {"tableWrap":"styles_tableWrap__pBNx3","emptyState":"styles_emptyState__brdBZ","pagination":"styles_pagination__E06rR"};